import { client } from '@core/api/API'

export default {
  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchSupplyTypes() {
    return client.get('/supply-types')
  },

  /**
   * @param {{
   *  numberOfPlants?: number,
   *  supplyTypeId?: string,
   *  category?: string,
   *  brand?: string,
   *  search?: string,
   *  page?: number,
   *  limit?: number,
   * }} params
   * @returns {Promise<{ items: any[], total: number }>}
   */
  async fetchSupplyItems(params) {
    const response = await client.get('/supply-items', {
      params,
    })

    return response.data
  },

  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchSupplyItemBrands() {
    return client.get('/supply-items/brands')
  },

  /**
   * @param {{
   *   numberOfPlants?: number,
   *   budget?: string,
   *   location?: string,
   * }} params
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchSupplyShoppingLists(params) {
    return client.get('/supply-shopping-lists', {
      params,
    })
  },

  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchSupplyCategories() {
    return await client.get('/supply-items/categories')
      .then(res => res.data)
  },

  async createCustomSupplyItem(item) {
    return client.post('/supply-items/custom', item)
      .then(res => res.data)
  },

  async fetchSupplyRetailers() {
    return client.get('/supply-items/retailers')
      .then(res => res.data)
  },
}
